import React from "react"
import styles from "./footer.module.css"

const Footer = (props) => {
  return <div {...props}>Footer</div>
}

export default Footer